import { render, staticRenderFns } from "./ShopsPrices.vue?vue&type=template&id=c6eb9b3e"
import script from "./ShopsPrices.vue?vue&type=script&lang=js"
export * from "./ShopsPrices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports